import React from 'react';
import './App.css';
import Header from './Header';
import TrackerContainer from './TrackerContainer';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <TrackerContainer />
      <Footer />
    </div>
  );
}

export default App;
